import moment from 'moment'

export default function (date) {
  let from = moment(date[0]).format('YYYY-MM-DD HH:MM')
  let until = moment(date[1]).format('YYYY-MM-DD HH:MM')
  return `${from} - ${until}`
}



// WEBPACK FOOTER //
// ./src/services/dateConvert.js